<div *ngIf="csrStatus()" [class.hidden]="!datepickerService._state()" class="iho-datepicker w-full relative">
  <ng-container *ngIf="!datepickerService._isMobile()">
    <div #datepickerWrapper
      class="w-[670px] lg:w-[694px] datepicker-layout p-4 bg-white border-2 border-solid border-gray-200 rounded-2xl absolute top-[calc(100%+8px)] z-[5000]"
      [ngClass]="{'-right-14': reservable}">
      <div class="flex justify-between">
        <div class="flex items-center">
          <div *ngIf="datepickerService._unReservable().length !== 0" class="flex items-center gap-6">
            <div [ngClass]="tip === '1' ? 'opacity-100 delay-100': 'opacity-25 transition delay-150'">
              <div class="w-4 h-4 mx-auto bg-gray-200 rounded-md"></div>
              <small>
                غیر قابل رزرو
              </small>
            </div>
            <div [ngClass]="tip === '2' ? 'opacity-100 delay-100': 'opacity-25 transition delay-150'">
              <div class="w-4 h-4 mx-auto bg-orange-200 rounded-md"></div>
              <small>
                محدودیت ورود
              </small>
            </div>
            <div [ngClass]="tip === '3' ? 'opacity-100 delay-100': 'opacity-25'">
              <div class="w-4 h-4 mx-auto bg-red-200 rounded-md"></div>
              <small>
                محدودیت خروج
              </small>
            </div>
          </div>
          <small *ngIf="datepickerService._unReservable().length === 0 && tip !== ''"
            class="p-1 rounded-md bg-red-50 text-red-500">
            {{tip.includes("جمعه") ? "" : tip}}
          </small>
        </div>
        <button (click)="reset()"
          class="p-1.5 font-medium text-blue-500 border border-solid border-blue-500 rounded-lg">
          برو به امروز
        </button>
      </div>
      <div class="w-full h-[2px] my-2 bg-gray-200"></div>
      <div class="flex justify-between">
        <div class="flex justify-start items-center gap-20 text-blue-500">
          <div (click)="navigateMonth('previous')" [class.cursor-not-allowed]="notAllowCursorPrevMonth"
            [class.text-gray-500]="notAllowCursorPrevMonth" [class.cursor-pointer]="!notAllowCursorPrevMonth"
            class="flex items-center text-blue-500">
            <i class="ico-Right text-2xl"></i>
            <p>
              ماه قبل
            </p>
          </div>
          <p class="text-black font-bold">
            {{datepickerPack[desktopToggle[0]]?.sectionMonthTitle}}
            {{datepickerPack[desktopToggle[0]]?.sectionYear}}
          </p>
        </div>
        <div class="flex justify-end items-center gap-20">
          <p class="text-black font-bold">
            {{datepickerPack[desktopToggle[1]]?.sectionMonthTitle}}
            {{datepickerPack[desktopToggle[1]]?.sectionYear}}
          </p>
          <div (click)="navigateMonth('next')" [class.cursor-not-allowed]="notAllowCursorNextMonth"
            [class.text-gray-500]="notAllowCursorNextMonth" [class.cursor-pointer]="!notAllowCursorNextMonth"
            class="flex items-center text-blue-500">
            <p>
              ماه بعد
            </p>
            <i class="ico-Left text-2xl"></i>
          </div>
        </div>
      </div>
      <div (mouseout)="tip=''" class="flex justify-between gap-4">
        <div [class.hidden]="datepickerVisibility[0]" class="w-full">
          <div *ngIf="datepickerService._locale() === 'fa'"
            class="grid grid-cols-7 grid-rows-1 justify-around gap-5 my-2 p-1.5 text-center text-slate-500 bg-gray-100 rounded-md">
            <small>
              ش
            </small>
            <small>
              ی
            </small>
            <small>
              د
            </small>
            <small>
              س
            </small>
            <small>
              چ
            </small>
            <small>
              پ
            </small>
            <small>
              ج
            </small>
          </div>
          <div *ngIf="datepickerService._locale() === 'en'"
            class="grid grid-cols-7 grid-rows-1 justify-around gap-5 my-2 p-1.5 text-center text-slate-500 bg-gray-100 rounded-md">
            <small>
              Sat
            </small>
            <small>
              Sun
            </small>
            <small>
              Mon
            </small>
            <small>
              Tue
            </small>
            <small>
              Wed
            </small>
            <small>
              Thi
            </small>
            <small>
              Fri
            </small>
          </div>
          <div class="grid grid-cols-7 grid-rows-4 gap-1 text-center">
            <ng-container *ngFor="let daysOfMonthItem of datepickerPack[0].sectionDaysOfMonthArray let index = index">
              <div
                (click)="selectDate(datepickerPack[0].sectionYear, datepickerPack[0].sectionMonth, index-datepickerPack[0].sectionFirstDay + 1, $event)"
                (mouseover)="setTooltip(datepickerPack[0].sectionYear, datepickerPack[0].sectionMonth, index-datepickerPack[0].sectionFirstDay + 1)"
                #cell *ngIf="index >= datepickerPack[0].sectionFirstDay"
                [ngClass]="(datepickerService._locale() === 'fa' && +jalaliToday.split('/')[2] === +index-datepickerPack[0].sectionFirstDay + 1 && +jalaliToday.split('/')[1] === datepickerPack[0].sectionMonth) || (datepickerService._locale() === 'en' && +gregorianToday.split('/')[2] === +index-datepickerPack[0].sectionFirstDay + 1 && +gregorianToday.split('/')[1] === datepickerPack[0].sectionMonth) ? 'border-gray-700 z-animation' : 'border-gray-200'"
                class="cell border border-solid rounded-md cursor-pointer relative">
                <div>
                  <div class="w-full h-full overflow-hidden absolute">
                    <div
                      *ngIf="isUnreservable(datepickerPack[0].sectionYear, datepickerPack[0].sectionMonth, index-datepickerPack[0].sectionFirstDay + 1) === 1"
                      class="diagonal gray"></div>
                    <div
                      *ngIf="isUnreservable(datepickerPack[0].sectionYear, datepickerPack[0].sectionMonth, index-datepickerPack[0].sectionFirstDay + 1) === 3"
                      class="diagonal orange"></div>
                    <div
                      *ngIf="isUnreservable(datepickerPack[0].sectionYear, datepickerPack[0].sectionMonth, index-datepickerPack[0].sectionFirstDay + 1) === 3"
                      class="half-diagonal"></div>
                    <div
                      *ngIf="isUnreservable(datepickerPack[0].sectionYear, datepickerPack[0].sectionMonth, index-datepickerPack[0].sectionFirstDay + 1) === 4"
                      class="diagonal red"></div>
                    <div
                      *ngIf="isUnreservable(datepickerPack[0].sectionYear, datepickerPack[0].sectionMonth, index-datepickerPack[0].sectionFirstDay + 1) === 4"
                      class="half-diagonal"></div>
                  </div>
                  <input #cellInput type="hidden"
                    value="{{datepickerPack[0].sectionYear}}/{{datepickerPack[0].sectionMonth}}/{{index-datepickerPack[0].sectionFirstDay + 1}}" />
                  <div class="flex justify-around">
                    <div>
                      <small
                        *ngIf="!isHoliday(datepickerPack[0].sectionYear, datepickerPack[0].sectionMonth, index-datepickerPack[0].sectionFirstDay + 1) && isDisable(datepickerPack[0].sectionYear, datepickerPack[0].sectionMonth, index-datepickerPack[0].sectionFirstDay + 1) === true">
                        {{index-datepickerPack[0].sectionFirstDay + 1}}
                      </small>
                      <small
                        *ngIf="isHoliday(datepickerPack[0].sectionYear, datepickerPack[0].sectionMonth, index-datepickerPack[0].sectionFirstDay + 1) && datepickerService._state() && isDisable(datepickerPack[0].sectionYear, datepickerPack[0].sectionMonth, index-datepickerPack[0].sectionFirstDay + 1) === true"
                        class="text-red-500">
                        {{index-datepickerPack[0].sectionFirstDay + 1}}
                      </small>
                      <small
                        *ngIf="!isHoliday(datepickerPack[0].sectionYear, datepickerPack[0].sectionMonth, index-datepickerPack[0].sectionFirstDay + 1) && isDisable(datepickerPack[0].sectionYear, datepickerPack[0].sectionMonth, index-datepickerPack[0].sectionFirstDay + 1) === false"
                        class="disabled text-gray-200 relative">
                        {{index-datepickerPack[0].sectionFirstDay + 1}}
                      </small>
                      <small
                        *ngIf="isHoliday(datepickerPack[0].sectionYear, datepickerPack[0].sectionMonth, index-datepickerPack[0].sectionFirstDay + 1) && datepickerService._state() && isDisable(datepickerPack[0].sectionYear, datepickerPack[0].sectionMonth, index-datepickerPack[0].sectionFirstDay + 1) === false"
                        class="disabled text-red-200 relative">
                        {{index-datepickerPack[0].sectionFirstDay + 1}}
                      </small>
                    </div>
                    <div>
                      &nbsp;
                    </div>
                  </div>
                  <div class="-mt-2">
                    <small class="text-blue-500">
                      {{hasPrice(datepickerPack[0].sectionYear, datepickerPack[0].sectionMonth,
                      index-datepickerPack[0].sectionFirstDay + 1) !==
                      '0' ? hasPrice(datepickerPack[0].sectionYear,
                      datepickerPack[0].sectionMonth,
                      index-datepickerPack[0].sectionFirstDay + 1):
                      '&nbsp;'}}
                    </small>
                  </div>
                </div>
              </div>
              <div *ngIf="index < datepickerPack[0].sectionFirstDay" class="p-2">
                <div class="relative">
                  <small>
                    &nbsp;
                  </small>
                </div>
              </div>
            </ng-container>
          </div>
        </div>
        <div [class.hidden]="datepickerVisibility[1]" class="w-full">
          <div *ngIf="datepickerService._locale() === 'fa'"
            class="grid grid-cols-7 grid-rows-1 justify-around gap-5 my-2 p-1.5 text-center text-slate-500 bg-gray-100 rounded-md">
            <small>
              ش
            </small>
            <small>
              ی
            </small>
            <small>
              د
            </small>
            <small>
              س
            </small>
            <small>
              چ
            </small>
            <small>
              پ
            </small>
            <small>
              ج
            </small>
          </div>
          <div *ngIf="datepickerService._locale() === 'en'"
            class="grid grid-cols-7 grid-rows-1 justify-around gap-5 my-2 p-1.5 text-center text-slate-500 bg-gray-100 rounded-md">
            <small>
              Sat
            </small>
            <small>
              Sun
            </small>
            <small>
              Mon
            </small>
            <small>
              Tue
            </small>
            <small>
              Wed
            </small>
            <small>
              Thi
            </small>
            <small>
              Fri
            </small>
          </div>
          <div class="grid grid-cols-7 grid-rows-4 gap-1 text-center">
            <ng-container *ngFor="let daysOfMonthItem of datepickerPack[1].sectionDaysOfMonthArray let index = index">
              <div
                (click)="selectDate(datepickerPack[1].sectionYear, datepickerPack[1].sectionMonth, index-datepickerPack[1].sectionFirstDay + 1, $event)"
                (mouseover)="setTooltip(datepickerPack[1].sectionYear, datepickerPack[1].sectionMonth, index-datepickerPack[1].sectionFirstDay + 1)"
                #cell *ngIf="index >= datepickerPack[1].sectionFirstDay"
                class="cell border border-solid rounded-md cursor-pointer relative">
                <div class="w-full h-full overflow-hidden absolute">
                  <ng-container
                    *ngIf="isUnreservable(datepickerPack[1].sectionYear, datepickerPack[1].sectionMonth, index-datepickerPack[1].sectionFirstDay + 1) === 1">
                    <div class="diagonal gray"></div>
                  </ng-container>
                  <ng-container
                    *ngIf="isUnreservable(datepickerPack[1].sectionYear, datepickerPack[1].sectionMonth, index-datepickerPack[1].sectionFirstDay + 1) === 3">
                    <div class="diagonal orange"></div>
                    <div class="half-diagonal"></div>
                  </ng-container>
                  <ng-container
                    *ngIf="isUnreservable(datepickerPack[1].sectionYear, datepickerPack[1].sectionMonth, index-datepickerPack[1].sectionFirstDay + 1) === 4">
                    <div class="diagonal red"></div>
                    <div class="half-diagonal"></div>
                  </ng-container>
                </div>
                <input #cellInput type="hidden"
                  value="{{datepickerPack[1].sectionYear}}/{{datepickerPack[1].sectionMonth}}/{{index-datepickerPack[1].sectionFirstDay + 1}}" />
                <div class="flex justify-around">
                  <div>
                    <small
                      *ngIf="!isHoliday(datepickerPack[1].sectionYear, datepickerPack[1].sectionMonth, index-datepickerPack[1].sectionFirstDay + 1) && isDisable(datepickerPack[1].sectionYear, datepickerPack[1].sectionMonth, index-datepickerPack[1].sectionFirstDay + 1) === true">
                      {{index-datepickerPack[1].sectionFirstDay + 1}}
                    </small>
                    <small
                      *ngIf="isHoliday(datepickerPack[1].sectionYear, datepickerPack[1].sectionMonth, index-datepickerPack[1].sectionFirstDay + 1) && datepickerService._state() && isDisable(datepickerPack[1].sectionYear, datepickerPack[1].sectionMonth, index-datepickerPack[1].sectionFirstDay + 1) === true"
                      class="text-red-500">
                      {{index-datepickerPack[1].sectionFirstDay + 1}}
                    </small>
                    <small
                      *ngIf="!isHoliday(datepickerPack[1].sectionYear, datepickerPack[1].sectionMonth, index-datepickerPack[1].sectionFirstDay + 1) && isDisable(datepickerPack[1].sectionYear, datepickerPack[1].sectionMonth, index-datepickerPack[1].sectionFirstDay + 1) === false"
                      class="disabled text-gray-200 relative">
                      {{index-datepickerPack[1].sectionFirstDay + 1}}
                    </small>
                    <small
                      *ngIf="isHoliday(datepickerPack[1].sectionYear, datepickerPack[1].sectionMonth, index-datepickerPack[1].sectionFirstDay + 1) && datepickerService._state() && isDisable(datepickerPack[1].sectionYear, datepickerPack[1].sectionMonth, index-datepickerPack[1].sectionFirstDay + 1) === false"
                      class="disabled text-red-200 relative">
                      {{index-datepickerPack[1].sectionFirstDay + 1}}
                    </small>
                  </div>
                  <div>
                    &nbsp;
                  </div>
                </div>
                <div class="-mt-2">
                  <small class="text-blue-500">
                    {{hasPrice(datepickerPack[1].sectionYear, datepickerPack[1].sectionMonth,
                    index-datepickerPack[1].sectionFirstDay + 1) !==
                    '0' ? hasPrice(datepickerPack[1].sectionYear, datepickerPack[1].sectionMonth,
                    index-datepickerPack[1].sectionFirstDay + 1):
                    '&nbsp;'}}
                  </small>
                </div>
              </div>
              <div *ngIf="index < datepickerPack[1].sectionFirstDay" class="p-2">
                <div class="relative">
                  <small>
                    &nbsp;
                  </small>
                </div>
              </div>
            </ng-container>
          </div>
        </div>
      </div>
      <div class="w-full h-[2px] my-3 bg-gray-200"></div>
      <div class="flex items-center justify-between gap-2 text-gray-500">
        <div>
          <button (click)="datepickerService.setUnReservable(datepickerService._unReservableBU()); reset()"
            class="p-1.5 text-blue-500 border border-solid border-blue-500 rounded-lg">
            پاک کردن
          </button>
        </div>
        <div class="flex items-center gap-2">
          <p class="text-sm">
            تاریخ ورود
            <span *ngIf="startDate !== ''" class="text-black font-bold">
              {{customStartDate}}
            </span>
          </p>
          ،
          <p class="text-sm">
            تاریخ خروج
            <span *ngIf="endDate !== ''" class="text-black font-bold">
              {{customEndDate}}
            </span>
          </p>
          <button *ngIf="startDate === '' || endDate === ''"
            class="py-1.5 px-6 text-gray-500 bg-gray-200 border border-solid border-gray-200 rounded-lg">
            تایید تاریخ
          </button>
          <button (click)="submitDate()" *ngIf="startDate !== '' && endDate !== ''"
            class="py-1.5 px-6 text-white bg-blue-500 border border-solid border-blue-500 rounded-lg">
            تایید تاریخ
            <ng-container *ngIf="duration.length !== 0">
              ({{duration.length -1}} شب)
            </ng-container>
          </button>
        </div>
      </div>
    </div>
  </ng-container>
  <ng-container *ngIf="datepickerService._isMobile()">
    <div class="w-full h-[100dvh] p-2 border relative">
      <div class="w-full sticky">
        <div class="flex justify-between items-center">
          <header (click)="datepickerService.setState(false); datepickerService.setAllowToShow(true)"
            class="flex items-center gap-4">
            <i class="ico-ArrowRight text-2xl"></i>
            <p class="text-lg">
              انتخاب تاریخ
            </p>

          </header>
          <div class="flex gap-2">
            <button (click)="reset()"
              class="p-1.5 font-medium text-blue-500 border border-solid border-blue-500 rounded-lg">
              برو به امروز
            </button>
          </div>
        </div>
        <div class="w-full h-[2px] mt-2 mb-1 bg-gray-200"></div>
        <div class="flex justify-between">
          <div (click)="navigateMonth('previous')" [class.cursor-not-allowed]="notAllowCursorPrevMonth"
            [class.text-gray-500]="notAllowCursorPrevMonth" [class.cursor-pointer]="!notAllowCursorPrevMonth"
            class="flex items-center text-blue-500">
            <i class="ico-Right text-2xl"></i>
            <p>
              ماه قبل
            </p>
          </div>
          <div (click)="navigateMonth('next')" [class.cursor-not-allowed]="notAllowCursorNextMonth"
            [class.text-gray-500]="notAllowCursorNextMonth" [class.cursor-pointer]="!notAllowCursorNextMonth"
            class="flex items-center text-blue-500">
            <p>
              ماه بعد
            </p>
            <i class="ico-Left text-2xl"></i>
          </div>
        </div>
        <div class="grid grid-cols-7 grid-rows-1 justify-around gap-5 p-1.5 text-center bg-gray-100 rounded-md">
          <small>
            ش
          </small>
          <small>
            ی
          </small>
          <small>
            د
          </small>
          <small>
            س
          </small>
          <small>
            چ
          </small>
          <small>
            پ
          </small>
          <small>
            ج
          </small>
        </div>
      </div>
      <div class="hide-scroll w-full h-[calc(100%-244px)] overflow-y-scroll">
        <div class="mt-2">
          <div class="flex justify-center items-center gap-6 h-[38px] py-2">
            <p>
              {{datepickerPack[0].sectionMonthTitle}} {{datepickerPack[0].sectionYear}}
            </p>
          </div>
          <div class="grid grid-cols-7 grid-rows-4 gap-1 text-center">
            <ng-container *ngFor="let daysOfMonthItem of datepickerPack[0].sectionDaysOfMonthArray let index = index">
              <div #cell *ngIf="index >= datepickerPack[0].sectionFirstDay"
                (click)="selectDate(datepickerPack[0].sectionYear, datepickerPack[0].sectionMonth, index-datepickerPack[0].sectionFirstDay + 1, $event)"
                [ngClass]="(datepickerService._locale() === 'fa' && +jalaliToday.split('/')[2] === +index-datepickerPack[0].sectionFirstDay + 1 && +jalaliToday.split('/')[1] === datepickerPack[0].sectionMonth) || (datepickerService._locale() === 'en' && +gregorianToday.split('/')[2] === +index-datepickerPack[0].sectionFirstDay + 1 && +gregorianToday.split('/')[1] === datepickerPack[0].sectionMonth) ? 'border-gray-700 z-animation' : 'border-gray-200'"
                class="cell border border-solid rounded-md cursor-pointer relative">
                <div class="w-full h-full overflow-hidden absolute">
                  <ng-container
                    *ngIf="isUnreservable(datepickerPack[0].sectionYear, datepickerPack[0].sectionMonth, index-datepickerPack[0].sectionFirstDay + 1) === 1">
                    <div class="diagonal gray"></div>
                  </ng-container>
                  <ng-container
                    *ngIf="isUnreservable(datepickerPack[0].sectionYear, datepickerPack[0].sectionMonth, index-datepickerPack[0].sectionFirstDay + 1) === 3">
                    <div class="diagonal orange"></div>
                    <div class="half-diagonal"></div>
                  </ng-container>
                  <ng-container
                    *ngIf="isUnreservable(datepickerPack[0].sectionYear, datepickerPack[0].sectionMonth, index-datepickerPack[0].sectionFirstDay + 1) === 4">
                    <div class="diagonal red"></div>
                    <div class="half-diagonal"></div>
                  </ng-container>
                </div>
                <input #cellInput type="hidden"
                  value="{{datepickerPack[0].sectionYear}}/{{datepickerPack[0].sectionMonth}}/{{index-datepickerPack[0].sectionFirstDay + 1}}" />
                <div class="flex justify-around">
                  <div>
                    <small
                      *ngIf="!isHoliday(datepickerPack[0].sectionYear, datepickerPack[0].sectionMonth, index-datepickerPack[0].sectionFirstDay + 1) && isDisable(datepickerPack[0].sectionYear, datepickerPack[0].sectionMonth, index-datepickerPack[0].sectionFirstDay + 1) === true">
                      {{index-datepickerPack[0].sectionFirstDay + 1}}
                    </small>
                    <ng-container *ngIf="datepickerService._locale() === 'fa'">
                      <small
                        *ngIf="isHoliday(datepickerPack[0].sectionYear, datepickerPack[0].sectionMonth, index-datepickerPack[0].sectionFirstDay + 1) && datepickerService._state() && isDisable(datepickerPack[0].sectionYear, datepickerPack[0].sectionMonth, index-datepickerPack[0].sectionFirstDay + 1) === true"
                        class="text-red-500">
                        {{index-datepickerPack[0].sectionFirstDay + 1}}
                      </small>
                    </ng-container>
                    <ng-container *ngIf="datepickerService._locale() === 'en'">
                      <small
                        *ngIf="!isHoliday(datepickerPack[0].sectionYear, datepickerPack[0].sectionMonth, index-datepickerPack[0].sectionFirstDay + 1) && datepickerService._state() && isDisable(datepickerPack[0].sectionYear, datepickerPack[0].sectionMonth, index-datepickerPack[0].sectionFirstDay + 1) === true">
                        {{index-datepickerPack[0].sectionFirstDay + 1}}
                      </small>
                    </ng-container>
                    <small
                      *ngIf="!isHoliday(datepickerPack[0].sectionYear, datepickerPack[0].sectionMonth, index-datepickerPack[0].sectionFirstDay + 1) && isDisable(datepickerPack[0].sectionYear, datepickerPack[0].sectionMonth, index-datepickerPack[0].sectionFirstDay + 1) === false"
                      class="disabled text-gray-300 relative">
                      {{index-datepickerPack[0].sectionFirstDay + 1}}
                    </small>
                    <small
                      *ngIf="isHoliday(datepickerPack[0].sectionYear, datepickerPack[0].sectionMonth, index-datepickerPack[0].sectionFirstDay + 1) && datepickerService._state() && isDisable(datepickerPack[0].sectionYear, datepickerPack[0].sectionMonth, index-datepickerPack[0].sectionFirstDay + 1) === false"
                      class="disabled text-red-200 relative">
                      {{index-datepickerPack[0].sectionFirstDay + 1}}
                    </small>
                  </div>
                  <div>
                    &nbsp;
                  </div>
                </div>
                <div class="-mt-2">
                  <small class="text-blue-500">
                    {{hasPrice(datepickerPack[0].sectionYear, datepickerPack[0].sectionMonth,
                    index-datepickerPack[0].sectionFirstDay + 1)
                    !==
                    '0' ? hasPrice(datepickerPack[0].sectionYear, datepickerPack[0].sectionMonth,
                    index-datepickerPack[0].sectionFirstDay +
                    1):
                    '&nbsp;'}}
                  </small>
                </div>
              </div>
              <div *ngIf="index < datepickerPack[0].sectionFirstDay" class="p-2">
                <div class="relative">
                  <small>
                    &nbsp;
                  </small>
                </div>
              </div>
            </ng-container>
          </div>
        </div>
        <div class="mt-2">
          <div class="flex justify-center items-center gap-6 h-[38px] py-2">
            <p>
              {{datepickerPack[1].sectionMonthTitle}} {{datepickerPack[1].sectionYear}}
            </p>
          </div>
          <div class="grid grid-cols-7 grid-rows-4 gap-1 text-center">
            <ng-container *ngFor="let daysOfMonthItem of datepickerPack[1].sectionDaysOfMonthArray let index = index">
              <div #cell *ngIf="index >= datepickerPack[1].sectionFirstDay"
                (click)="selectDate(datepickerPack[1].sectionYear, datepickerPack[1].sectionMonth, index-datepickerPack[1].sectionFirstDay + 1, $event)"
                class="cell border border-solid rounded-md cursor-pointer relative">
                <div class="w-full h-full overflow-hidden absolute">
                  <ng-container
                    *ngIf="isUnreservable(datepickerPack[1].sectionYear, datepickerPack[1].sectionMonth, index-datepickerPack[1].sectionFirstDay + 1) === 1">
                    <div class="diagonal gray"></div>
                  </ng-container>
                  <ng-container
                    *ngIf="isUnreservable(datepickerPack[1].sectionYear, datepickerPack[1].sectionMonth, index-datepickerPack[1].sectionFirstDay + 1) === 3">
                    <div class="diagonal orange"></div>
                    <div class="half-diagonal"></div>
                  </ng-container>
                  <ng-container
                    *ngIf="isUnreservable(datepickerPack[1].sectionYear, datepickerPack[1].sectionMonth, index-datepickerPack[1].sectionFirstDay + 1) === 4">
                    <div class="diagonal red"></div>
                    <div class="half-diagonal"></div>
                  </ng-container>
                </div>
                <input #cellInput type="hidden"
                  value="{{datepickerPack[1].sectionYear}}/{{datepickerPack[1].sectionMonth}}/{{index-datepickerPack[1].sectionFirstDay + 1}}" />
                <div class="flex justify-around">
                  <div>
                    <small
                      *ngIf="!isHoliday(datepickerPack[1].sectionYear, datepickerPack[1].sectionMonth, index-datepickerPack[1].sectionFirstDay + 1) && isDisable(datepickerPack[1].sectionYear, datepickerPack[1].sectionMonth, index-datepickerPack[1].sectionFirstDay + 1) === true">
                      {{index-datepickerPack[1].sectionFirstDay + 1}}
                    </small>
                    <ng-container *ngIf="datepickerService._locale() === 'fa'">
                      <small
                        *ngIf="isHoliday(datepickerPack[1].sectionYear, datepickerPack[1].sectionMonth, index-datepickerPack[1].sectionFirstDay + 1) && datepickerService._state() && isDisable(datepickerPack[1].sectionYear, datepickerPack[1].sectionMonth, index-datepickerPack[1].sectionFirstDay + 1) === true"
                        class="text-red-500">
                        {{index-datepickerPack[1].sectionFirstDay + 1}}
                      </small>
                    </ng-container>
                    <ng-container *ngIf="datepickerService._locale() === 'en'">
                      <small
                        *ngIf="!isHoliday(datepickerPack[1].sectionYear, datepickerPack[1].sectionMonth, index-datepickerPack[1].sectionFirstDay + 1) && datepickerService._state() && isDisable(datepickerPack[1].sectionYear, datepickerPack[1].sectionMonth, index-datepickerPack[1].sectionFirstDay + 1) === true">
                        {{index-datepickerPack[1].sectionFirstDay + 1}}
                      </small>
                    </ng-container>
                    <small
                      *ngIf="!isHoliday(datepickerPack[1].sectionYear, datepickerPack[1].sectionMonth, index-datepickerPack[1].sectionFirstDay + 1) && isDisable(datepickerPack[1].sectionYear, datepickerPack[1].sectionMonth, index-datepickerPack[1].sectionFirstDay + 1) === false"
                      class="disabled text-gray-300 relative">
                      {{index-datepickerPack[1].sectionFirstDay + 1}}
                    </small>
                    <small
                      *ngIf="isHoliday(datepickerPack[1].sectionYear, datepickerPack[1].sectionMonth, index-datepickerPack[1].sectionFirstDay + 1) && datepickerService._state() && isDisable(datepickerPack[1].sectionYear, datepickerPack[1].sectionMonth, index-datepickerPack[1].sectionFirstDay + 1) === false"
                      class="disabled text-red-200 relative">
                      {{index-datepickerPack[1].sectionFirstDay + 1}}
                    </small>
                  </div>
                  <div>
                    &nbsp;
                  </div>
                </div>
                <div class="-mt-2">
                  <small class="text-blue-500">
                    {{hasPrice(datepickerPack[1].sectionYear,
                    datepickerPack[1].sectionMonth,
                    index-datepickerPack[1].sectionFirstDay + 1)
                    !==
                    '0' ? hasPrice(datepickerPack[1].sectionYear,
                    datepickerPack[1].sectionMonth,
                    index-datepickerPack[1].sectionFirstDay +
                    1):
                    '&nbsp;'}}
                  </small>
                </div>
              </div>
              <div *ngIf="index < datepickerPack[1].sectionFirstDay" class="p-2">
                <div class="relative">
                  <small>
                    &nbsp;
                  </small>
                </div>
              </div>
            </ng-container>
          </div>
        </div>
      </div>
      <div class="w-full p-2 absolute right-0 bottom-0 bg-white">
        <div>
          <div *ngIf="datepickerService._unReservable().length !== 0"
            class="flex justify-between items-center gap-6 px-4">
            <div>
              <div class="w-4 h-4 mx-auto bg-gray-200 rounded-md"></div>
              <small>
                غیر قابل رزرو
              </small>
            </div>
            <div>
              <div class="w-4 h-4 mx-auto bg-orange-200 rounded-md"></div>
              <small>
                محدودیت ورود
              </small>
            </div>
            <div>
              <div class="w-4 h-4 mx-auto bg-red-200 rounded-md"></div>
              <small>
                محدودیت خروج
              </small>
            </div>
          </div>
        </div>
        <div class="w-full h-[2px] mb-2 bg-gray-200"></div>
        <div class="flex gap-4 mb-2">
          <input class="w-full p-3 border border-solid border-slate-300 rounded-lg" placeholder="تاریخ ورود"
            [value]="startDate !== '' ? customStartDate : ''" readonly />
          <i class="p-2 ico-ArrowLeft text-2xl text-gray-500"></i>
          <input class="w-full p-3 border border-solid border-slate-300 rounded-lg" placeholder="تاریخ خروج"
            [value]="endDate !== '' ? customEndDate : ''" readonly />
        </div>
        <div class="flex grow gap-4">
          <button *ngIf="datepickerService._unReservable().length !== 0"
            (click)="datepickerService.setUnReservable(datepickerService._unReservableBU()); reset()"
            class="w-full p-1.5 text-blue-500 border border-solid border-blue-500 rounded-lg !h-11 !text-base">
            پاک کردن
          </button>
          <button (click)="submitDate()" mat-flat-button color="primary" [disabled]="startDate === '' || endDate === ''"
            class="w-full !h-11 !text-base">
            تایید تاریخ
            <ng-container *ngIf="duration.length !== 0">
              ({{duration.length -1}} شب)
            </ng-container>
          </button>
        </div>
      </div>
    </div>
  </ng-container>
</div>
